/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FundHistoryDtoFinancialPlan
 */
export interface FundHistoryDtoFinancialPlan {
  /**
   *
   * @type {string}
   * @memberof FundHistoryDtoFinancialPlan
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof FundHistoryDtoFinancialPlan
   */
  number: number;
  /**
   *
   * @type {Date}
   * @memberof FundHistoryDtoFinancialPlan
   */
  createdAt: Date;
  /**
   *
   * @type {Date}
   * @memberof FundHistoryDtoFinancialPlan
   */
  from: Date;
  /**
   *
   * @type {Date}
   * @memberof FundHistoryDtoFinancialPlan
   */
  to: Date;
  /**
   *
   * @type {number}
   * @memberof FundHistoryDtoFinancialPlan
   */
  month: number;
  /**
   *
   * @type {number}
   * @memberof FundHistoryDtoFinancialPlan
   */
  year: number;
}

export function FundHistoryDtoFinancialPlanFromJSON(json: any): FundHistoryDtoFinancialPlan {
  return FundHistoryDtoFinancialPlanFromJSONTyped(json, false);
}

export function FundHistoryDtoFinancialPlanFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FundHistoryDtoFinancialPlan {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    number: json["number"],
    createdAt: new Date(json["createdAt"]),
    from: new Date(json["from"]),
    to: new Date(json["to"]),
    month: json["month"],
    year: json["year"],
  };
}

export function FundHistoryDtoFinancialPlanToJSON(value?: FundHistoryDtoFinancialPlan | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    number: value.number,
    createdAt: value.createdAt.toISOString(),
    from: value.from.toISOString(),
    to: value.to.toISOString(),
    month: value.month,
    year: value.year,
  };
}
